import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_CASE } from 'constants/urls';

/**
 * Fetches a single case by ID.
 * @param id - The case ID
 * @returns The API response data (single case object)
 * @throws Re-throws any Axios error after logging
 */
const getCase = async (id: number) => {
  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_CASE}?id=${id}`,
    );
    return data;
  } catch (error) {
    console.error('[getCase] Failed:', error);
    throw error;
  }
};

export default getCase;
